import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { HomeService } from '../../../../services/home.service';
import { TranslateService } from '../../../../services/translate.service';
import { Observable } from 'rxjs/internal/Observable';
import { EmployeesService } from '../../../../services/employees';
import { FinancialManagerService } from '../../../../services/financial-manager';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { AttendanceService } from '../../../../services/attendance';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserInterface } from '../../../../interfaces/user-interface';
import { BarcodeFormat } from '@zxing/library';


@Component({
  selector: 'app-employeefingerprint',
  templateUrl: './employeefingerprint.component.html',
  styleUrl: './employeefingerprint.component.scss'
})
export class EmployeefingerprintComponent {
  today = new Date();
  selectedYear!: number;
  selectedMonth!: string;
  month!: string; // الناتج النهائي بصيغة YYYY-MM
  years: number[] = [];
  months = [
    { value: '01', name_ar: 'يناير', name_en: 'January' },
    { value: '02', name_ar: 'فبراير', name_en: 'February' },
    { value: '03', name_ar: 'مارس', name_en: 'March' },
    { value: '04', name_ar: 'أبريل', name_en: 'April' },
    { value: '05', name_ar: 'مايو', name_en: 'May' },
    { value: '06', name_ar: 'يونيو', name_en: 'June' },
    { value: '07', name_ar: 'يوليو', name_en: 'July' },
    { value: '08', name_ar: 'أغسطس', name_en: 'August' },
    { value: '09', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];


  attendanceData: any;
  QrOption: boolean = false;
  contentReady: boolean = true;
  userId!: any;
  isAr: boolean = localStorage.getItem("language") == "ar";
  hasCheckedIn: boolean = false;
  hasCheckedOut: boolean = false;
  canCheckIn: boolean = true;
  accountType!: any;
  isAdmin!: any;
  hasaccess: boolean = false;
  allUsers: UserInterface[] = [];
  qrList: any[] = [];
  generatedQr: any;
  scanMode = false;
  allowedFormats = [BarcodeFormat.QR_CODE];
  constructor(private _router: Router,
    private _userService: UserService,
    private deviceService: DeviceDetectorService,
    private _homeService: HomeService,
    private attendanceService: AttendanceService
  ) {
    const today = new Date();
    this.selectedYear = today.getFullYear();
    this.selectedMonth = (today.getMonth() + 1).toString().padStart(2, '0');
    for (let y = 2015; y <= 2030; y++) {
      this.years.push(y);
    }
  }
  ngOnInit() {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = data['user_id'];

        this.checkInStatus();
        this.loadAttendance();
        this.loadQrCodes();
      },
      error: (error) => console.error(error),
    });
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1";
        this.hasaccess = this.accountType == "1" || this.accountType == "6";
        if (this.hasaccess)
          this.getAllUsers();
        this.checkInStatus();
        this.loadAttendance();

      },
      error: (error) => console.error(error),
    });

  }
  checkInStatus() {
    this.contentReady = true;
    this.attendanceService.getTodayCheckinStatus().subscribe(res => {
      this.hasCheckedIn = res.checked_in;
      this.hasCheckedOut = res.checked_out;
      this.contentReady = false;

      this.canCheckIn = !(this.hasCheckedIn && this.hasCheckedOut);
    });
  }
  getLocationAndCheck(type: 'in' | 'out') {
    this.contentReady = true;
    const deviceInfo = this.deviceService.getDeviceInfo();

    const payload =
      type === 'in'
        ? {
          check_in_device_time: new Date().toTimeString().split(' ')[0],
          check_in_server_time: new Date().toISOString(),
          device_info: JSON.stringify(deviceInfo),
          location_access_denied: 1,
        }
        : {
          check_out_device_time: new Date().toTimeString().split(' ')[0],
          check_out_server_time: new Date().toISOString(),
          device_info: JSON.stringify(deviceInfo),
          location_access_denied: 1,
        };

    if (type === 'in') {
      this.attendanceService.checkIn(payload).subscribe({
        next: () => {
          this.contentReady = false;
          Swal.fire('✔️', 'تم تسجيل الحضور', 'success').then(() => {
            location.reload();
          });
        },
        error: () => {
          this.contentReady = false;
          Swal.fire('❌', 'فشل تسجيل الحضور', 'error');
        },
      });
    } else {
      this.attendanceService.checkOut(payload).subscribe({
        next: () => {
          this.contentReady = false;
          Swal.fire('✔️', 'تم تسجيل الانصراف', 'success').then(() => {
            location.reload();
          });
        },
        error: () => {
          this.contentReady = false;
          Swal.fire('❌', 'فشل تسجيل الانصراف', 'error');
        },
      });
    }
  }


  loadAttendance() {
    this.contentReady = true;
    this.attendanceService.getMonthlyAttendance(this.userId, this.selectedMonth, String(this.selectedYear)).subscribe(res => {
      this.attendanceData = res.data;
      this.contentReady = false;
    });
  }
  getAllUsers() {
    this.contentReady = true;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.allUsers = data.filter((user: any) => user.type == 1 || user.type == 6 || user.type == 7 || user.type == 8 || user.type == 2);
        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }
  userFilter(id: any) {

    this.contentReady = true;
    this.attendanceService.getMonthlyAttendance(id, this.selectedMonth, String(this.selectedYear)).subscribe(res => {
      this.attendanceData = res.data;
      this.contentReady = false;
    });
  }
  extractDeviceInfo(deviceInfoString: string): string {
    if (!deviceInfoString) return '-';

    try {
      const data = JSON.parse(deviceInfoString);
      return `${data.deviceType || '-'} | ${data.device || '-'} | ${data.browser || '-'} | ${data.os_version || '-'}`;
    } catch {
      return '-';
    }
  }

  calculateDiff(inTime: string, outTime: string): string {
    if (!inTime || !outTime) return '-';

    const [inHours, inMinutes] = inTime.split(':').map(Number);
    const [outHours, outMinutes] = outTime.split(':').map(Number);

    const inDate = new Date();
    inDate.setHours(inHours, inMinutes, 0, 0);

    const outDate = new Date();
    outDate.setHours(outHours, outMinutes, 0, 0);

    let diffMs = outDate.getTime() - inDate.getTime();
    if (diffMs < 0) return '-'; // لو البيانات مش مظبوطة

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return this.isAr ? `${diffHours} ساعة ${diffMinutes} دقيقة` : `${diffHours} hours ${diffMinutes} minutes`;
  }

  loadQrCodes() {
    this.contentReady = true;
    this.attendanceService.getAllQrTokens(parseInt(localStorage.getItem('posId') || '0')).subscribe(res => {
      this.qrList = res;
      this.contentReady = false;
    });
  }

  generateQr() {
    this.attendanceService.generateQr({ warehouse_id: parseInt(localStorage.getItem('posId') || '0'), type: 'check_in' }).subscribe(res => {
      this.generatedQr = res.qr_code;
      this.loadQrCodes();
    }, error => {
      Swal.fire('❌', 'المخزن ده عليه كيواركود', 'error');
    });
  }

  deleteQr(id: any) {
    this.attendanceService.deleteQr(id).subscribe(res => {
      Swal.fire('✅', 'تم حذف الكيواركود بنجاح', 'success');
      this.loadQrCodes(); // إعادة تحميل الكيواركودات بعد الحذف
    }, error => {
      Swal.fire('❌', 'فشل حذف الكيواركود', 'error');
    });
  }

  fixImageUrl(image: string) {
    if (!image) return '';

    // هيفصل الباث حسب "/" وياخد آخر جزء
    const fileName = image.split('/').pop();

    return "https://backendtest.blueboxpet.com/storage/app/public/qrcodes/" + fileName;
  }
  downloadQr(url: string) {
    // استخرج اسم الملف من اللينك (مثلاً qr_9.png)
    const fileName = url.split('/').pop() || 'qr-code.png';

    // أنشئ رابط مؤقت للتحميل
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // يخليها تتحمل بدل ما تتفتح

    // ضيفه للـ DOM واعمِل كليك تلقائي
    document.body.appendChild(link);
    link.click();

    // امسحه بعد التحميل
    document.body.removeChild(link);
  }
  onCodeResult(result: string) {
    this.contentReady = true;
    this.scanMode = false;
    try {
      const parsed = JSON.parse(result);
      console.log('Decoded:', parsed);

      // ✅ Validate Token بس
      this.attendanceService.validateQr({ token: parsed.token }).subscribe({
        next: (res) => {
          console.log('Validation response:', res);

          if (!this.hasCheckedIn) {
            // أول مرة → اعمل Check-In
            this.getLocationAndCheck('in');
          } else if (this.hasCheckedIn && !this.hasCheckedOut) {
            // لو عمل Check-In ولسه ما عملش Check-Out → اعمل Check-Out
            this.getLocationAndCheck('out');
          } else {
            Swal.fire('ℹ️', 'لقد قمت بالفعل بتسجيل الحضور والانصراف اليوم', 'info');
          }
        },
        error: () => {
          Swal.fire('❌', 'Invalid QR Code', 'error');
        }
      });
    } catch (e) {
      Swal.fire('❌', 'Invalid QR Format', 'error');
    }
  }

}
